import NaptimeResource from './NaptimeResource';

class SubscriptionNextBillDetails extends NaptimeResource {
  static RESOURCE_NAME = 'subscriptionNextBillDetails.v1';
}

export default SubscriptionNextBillDetails;
